import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = {
  class: "bg-top bg-no-repeat bg-cover bg-fixed text-left content-base whitespace-pre-wrap break-all",
  style: {"color":"rgb(168, 168, 168)","margin":"20px 18px 0px","padding":"0px","font-weight":"700"}
}
const _hoisted_3 = ["content"]
const _hoisted_4 = {
  key: 0,
  class: "w-full"
}
const _hoisted_5 = {
  class: "bg-top bg-no-repeat bg-cover bg-fixed content-base",
  style: {"border-bottom":"4px dotted rgb(216, 216, 216)","margin":"10px 18px 0px","padding":"0px 0px 7px"}
}
const _hoisted_6 = { class: "flex flex-wrap w-full items-center" }
const _hoisted_7 = { style: {"width":"calc(70%)"} }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = {
  class: "bg-top bg-no-repeat bg-cover bg-fixed content-base",
  style: {"margin":"0px","padding":"0px"}
}
const _hoisted_10 = {
  class: "bg-top bg-no-repeat bg-cover bg-fixed",
  style: {"margin":"0px","padding":"0px"}
}
const _hoisted_11 = { class: "flex flex-wrap justify-around w-full" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = {
  class: "bg-top bg-no-repeat bg-cover bg-fixed text-left content-base",
  style: {"font-size":"12pt","margin":"0px","padding":"0px","font-weight":"500"}
}
const _hoisted_14 = { class: "content-text-content" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = {
  class: "bg-top bg-no-repeat bg-cover bg-fixed text-left content-base",
  style: {"font-size":"8pt","margin":"0px","padding":"0px"}
}
const _hoisted_17 = { class: "content-text-content" }
const _hoisted_18 = { style: {"width":"calc(30%)"} }
const _hoisted_19 = { class: "w-full" }
const _hoisted_20 = {
  class: "bg-top bg-no-repeat bg-cover bg-fixed content-base flex flex-col items-stretch text-center",
  style: {"margin":"0px","padding":"0px"}
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "bg-top bg-no-repeat bg-cover bg-fixed w-full select-none content-button",
  style: {"color":"rgb(255, 255, 255)","background-color":"rgb(161, 161, 161)","font-size":"9pt","border":"1px solid rgb(161, 161, 161)","border-radius":"10px","margin":"0px 0.5rem","padding":"7px 2px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.akasatanas, (akasatana, index) => {
    return (_openBlock(), _createElementBlock("div", { key: index }, [
      (_ctx.common.tieUp && _ctx.common.tieUp.some(content => content.akasatana === akasatana))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, " ■" + _toDisplayString(akasatana), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.common.tieUp, (content) => {
        return (_openBlock(), _createElementBlock("div", {
          key: content.id,
          content: content
        }, [
          (akasatana===content.akasatana)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("span", _hoisted_14, [
                                    _createElementVNode("p", null, _toDisplayString(content.store), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("span", _hoisted_17, [
                                    _createElementVNode("p", null, "応募期間： " + _toDisplayString(_ctx.dayjs.tz(content.begin, 'Asia/Tokyo').format('YYYY年MM月DD日')) + " ～ " + _toDisplayString(_ctx.dayjs.tz(content.end, 'Asia/Tokyo').subtract(1, 'second').format('YYYY年MM月DD日')), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          (content.enable)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "bg-top bg-no-repeat bg-cover bg-fixed w-full select-none cursor-pointer content-button",
                                style: {"color":"rgb(255, 255, 255)","background-color":"rgb(230, 0, 18)","font-size":"9pt","border":"1px solid rgb(230, 0, 18)","border-radius":"10px","margin":"0px 0.5rem","padding":"7px 2px"},
                                onClick: ($event: any) => (_ctx.onGo(content))
                              }, " この企業で応募 ", 8, _hoisted_21))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, " 応募期間外 "))
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_3))
      }), 128))
    ]))
  }), 128))
}